import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
/**
 * The submit-mode string a given search mode routes as.
 *
 * Its own module rather than a second spelling at each call site: the outbound-PII
 * gate has to answer its consent card for the mode the submit will actually use,
 * because only an ASI submission dispatches a local subagent and so only it can
 * consume a kept-local file grant. Two copies of this rule would let the card offer
 * a hand-off that the submit then routes past, and the file would silently go
 * unprocessed.
 */
export function submitModeForSearchMode(mode) {
    return mode === SearchMode.ASI ? 'asi' : 'copilot';
}
//# sourceMappingURL=submitMode.js.map